import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
/* import { loadFull } from "tsparticles"; */
import { useMemo, useCallback } from "react";

const ParticlesAnimation = () => {
    const options = useMemo(() => {
        return {
            fullScreen: {
                enable: true,
            },
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        radius: 100,
                    },
                },
            },
            particles: {
                links: {
                    enable: true,
                },
                move: {
                    enable: true,
                    speed: { min: 1, max: 5 },
                },
                opacity: {
                    value: { min: 0.3, max: 0.7 },
                },
                size: {
                    value: { min: 1, max: 3 },
                },
            },
        };
    }, []);

    const particlesInit = useCallback((engine) => {
        console.log(engine);
        loadSlim(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        /*  await loadFull(engine); */
    }, []);

    return (
        <Particles id='tsparticles' options={options} init={particlesInit} />
    );
};

export default ParticlesAnimation;
